export { default } from './accordion';
// default types
export type { IAccordionProps } from './accordion';
